export const getDateInputValue = numDaysAgo => {
	const now = new Date();
	let date = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate() - numDaysAgo
	);
	const parts = new Intl.DateTimeFormat('en-US', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).formatToParts(date);
	date = parts.reduce((prev, curr) => {
		prev[curr.type] = curr.value;
		return prev;
	}, {});
	return `${date['year']}-${date['month']}-${date['day']}`;
};

export const delay = ms => {
	return new Promise(resolve => {
		setTimeout(resolve, ms);
	});
};

const DARKMODE_KEY = 'rds-darkmode';

/**
 * @returns {boolean}
 */
export const getDarkmodeStatus = () => {
	return JSON.parse(localStorage.getItem(DARKMODE_KEY)) === true;
};

/**
 * @param {boolean} status
 */
export const setDarkmodeStatus = status => {
	localStorage.setItem(DARKMODE_KEY, JSON.stringify(status));
};

/**
 * Wraps Promise so React.Suspense can handle it
 * @param {Promise<mixed>} promise
 * @returns {() => mixed}
 */
export const suspend = promise => {
	let status = 'pending';
	let result;

	const s = promise.then(
		value => {
			status = 'success';
			result = value;
		},
		error => {
			status = 'error';
			result = error;
		}
	);

	return () => {
		switch (status) {
			case 'pending':
				throw s;
			case 'success':
				return result;
			case 'error':
				throw result;
			default:
				throw new Error('Unknown status');
		}
	};
};
